import { render, staticRenderFns } from "./IndSubAnRePunManFill.vue?vue&type=template&id=5b08a234&scoped=true&"
import script from "./IndSubAnRePunManFill.vue?vue&type=script&lang=js&"
export * from "./IndSubAnRePunManFill.vue?vue&type=script&lang=js&"
import style0 from "./IndSubAnRePunManFill.vue?vue&type=style&index=0&id=5b08a234&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b08a234",
  null
  
)

export default component.exports